(function($, undefined) {

    "use strict";

    /**
     * @class ofcs.autocomplete
     */
    $.widget('ofcs.autocomplete', $.ui.autocomplete, {

        options: {
            displayKey: null
        },

        widgetEventPrefix: 'autocomplete',

        lastMenuData: [],

        /**
         * Initialize projectSelect
         *
         * @constructor
         */
        _create: function() {
            var self = this,
                element = this.element,
                allParents = element.parents().add(window);

            $.ui.autocomplete.prototype._create.call(this);

            // Active class for selected menu items
            this.menu.element.on('menufocus', function(event, ui) {
                $(this).children('.active').removeClass('active');
                ui.item.addClass('active');
            });

            element.on('autocompleteopen autocompletesearch', function(ui) {
                allParents.on('mousewheel keydown', self._disableScrollEvents);
            });

            element.on('autocompleteclose blur', function() {
                allParents.off('mousewheel keydown', self._disableScrollEvents);
            });

            element.on('autocompletechange', $.proxy(this._onAutocompleteChange, this));

            if (element.registerValidationEvent) {
                element.preventDefaultValidationEvents(["keyup"]);
            }
        },

        _disableScrollEvents: function (e) {
            var isKeydown    = e.type === 'keydown',
                isMousewheel = e.type === 'mousewheel',
                inMenu   = $(e.target).closest('.ui-menu').length,
                pageUp   = e.keyCode === $.ui.keyCode.PAGE_UP,
                pageDown = e.keyCode === $.ui.keyCode.PAGE_DOWN;

            if (
                (isKeydown && (pageUp || pageDown))
                    || (isMousewheel && !inMenu)
                ) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        _onAutocompleteChange: function(event, ui) {
            var lastMenuData = this.lastMenuData,
                element      = this.element;

            if (!ui.item && lastMenuData.length > 0) {
                $.each(lastMenuData, function(index, item) {
                    if (item.value === element.val()) {
                        ui.item = item;
                    }
                });
            }
        },

        /**
         * Bootstrap dropdown layout for autocomplete menu
         *
         * @param ul
         * @param items
         * @private
         */
        _renderMenu: function( ul, items ) {
            var self = this,
                options = this.options;

            ul.addClass('dropdown-menu');
            self.lastMenuData = [];
            $.each( items, function( index, item ) {
                self._renderItemData( ul, item );
            });
        },

        /**
         * Processing item data
         *
         * @param ul
         * @param item
         * @return {*}
         * @private
         */
        _renderItemData: function( ul, item ) {
            var term = this.term,
                wrapTerm, data, text;

            if (this.options.displayKey && item[this.options.displayKey] !== undefined) {
                text = item[this.options.displayKey];
            } else {
                text = item.label;
            }

            wrapTerm = function(text, term) {
                var exp;
                term = $.ui.autocomplete.escapeRegex(term);
                exp = new RegExp(['(', term, ')'].join(''), 'gi');
                return text.replace(exp, "<b>$1</b>");
            };

            data = {
                label: wrapTerm(text, term),
                value: text,
                data: item
            };

            this.lastMenuData.push(data);

            return this._renderItem( ul, data ).data( "ui-autocomplete-item", data );
        },

        /**
         * Insert item label as html instead of text
         *
         * @param ul
         * @param item
         * @return {Ext.dom.AbstractElement|jQuery}
         * @private
         */
        _renderItem: function( ul, item ) {
            return $("<li>")
                .append( $("<a>").html(item.label) )
                .appendTo(ul);
        }

    });

}(jQuery));
